import { Component, OnInit } from "@angular/core";

import { AppService } from "../../../app.service";

import { forkJoin } from "rxjs";
 
// 👇 Needed for Bootstrap Modal

declare var bootstrap: any;
 
@Component({

  selector: "app-school-teacher",

  templateUrl: "./school-teacher.component.html",

  styleUrls: ["./school-teacher.component.scss"],

})

export class SchoolTeacherComponent implements OnInit {

    isModalOpen = false;

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  selectedLanguage = "";

  font = "";

  fetchinData = true;

  ContentData: any[] = [];

  all_employee_data: any[] = [];

  all_teachers_info: any[] = [];

  paginated_teachers_info: any[] = [];

  schoolTeacher: any[] = [];
 
  selectedTeacher: any = null; // 👈 For modal
  selectedItem: any = null;


  length = 0;

  pageSize = 15;

  pageIndex = 0;

  totalPages: number[] = [];
 
  constructor(private appService: AppService) {}
 
  ngOnInit(): void {

    this.FetchSchoolTeacherInfo();

  }
 
  FetchSchoolTeacherInfo() {

    forkJoin([this.appService.getTeaherStaff()]).subscribe((response: any) => {

      console.log(response, "response FetchData");

      this.ContentData = response[0].data;

      console.log(this.ContentData, "Default Content Data");

      if (this.ContentData != null) {

        this.all_teachers_info = this.ContentData.filter(

          (x) => x.SalarySheet === "School Teacher" && x.IsActive === true
         

        );
          

        console.log(this.all_teachers_info, "All school teachers info");

        this.length = this.all_teachers_info.length;

        this.generatePageNumbers();

        this.paginateData();

      }

      this.fetchinData = false;

    });

  }
 
  onPageChange(pageIndex: number) {

    this.pageIndex = pageIndex;

    this.paginateData();

  }
 
  paginateData() {

    const startIndex = this.pageIndex * this.pageSize;

    const endIndex = startIndex + this.pageSize;

    this.paginated_teachers_info = this.all_teachers_info.slice(

      startIndex,

      endIndex

    );

  }
 
  generatePageNumbers() {

    const totalPageCount = Math.ceil(this.length / this.pageSize);

    this.totalPages = Array.from({ length: totalPageCount }, (_, i) => i + 1);

  }
 
  GetFontName() {

    switch (this.selectedLanguage) {

      case "en":

        return "Congenial";

      case "bn":

        return "Kalpurush";

      case "ar":

        return "Jameel Noori Nastaleeq";

    }

  }
 
  // 👇 This function opens the modal

  openTeacherModal(teacher: any) {

    this.selectedTeacher = teacher;

    const modalElement = document.getElementById("teacherModal");

    if (modalElement) {

      const modal = new bootstrap.Modal(modalElement);

      modal.show();

    }

  }

}

 